import React, { useEffect } from "react";
import useVerifyPayment from "../hooks/use-verify-payment";
import Text from "../components/atoms/text";
import { Link } from "react-router-dom";
import Button from "../components/atoms/button";

const CallbackPage = () => {
  const { paymentData, error, isLoading } = useVerifyPayment();
  // console.log(paymentData)


  return (
    <div className="h-dvh flex justify-center items-center">
      <div className="shadow-[0px_20px_25px_-20px_rgba(128,128,128,0.15)] m-auto text-center bg-BorderGray rounded p-4 w-1/4 max-[1020px]:w-[90%]">
        {paymentData ? (
          <>
            <Text className={`text-xl !text-green-500`}>{paymentData?.detail}</Text> 
          </>
        ) : (
          ''
        )}
        <Link to='/'>
          <Button className={`w-full mt-4`}>
            العودة إلى الصفحة الرئيسية
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default CallbackPage;
